import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store/store'
// routes
import defaultRoutes from './default'
import horizontalRoutes from './horizontal'
import boxedRoutes from './boxed'
import mini from './mini'

// session components
const SignUpOne = () => import('Views/session/SignUpOne')
const LoginOne = () => import('Views/session/LoginOne')
const LockScreen = () => import('Views/session/LockScreen')

const Auth0CallBack = () => import('Components/Auth0Callback/Auth0Callback')

Vue.use(Router)

const routes = [
  defaultRoutes,
  horizontalRoutes,
  boxedRoutes,
  mini,
  {
    path: '/callback',
    component: Auth0CallBack
  },
  {
    path: '/session/sign-up',
    component: SignUpOne,
    meta: {
      title: 'message.signUp',
      breadcrumb: 'Session / Sign Up'
    }
  },
  {
    path: '/account/login',
    component: LoginOne,
    meta: {
      title: 'message.login',
      breadcrumb: 'Account / Login'
    }
  },
  {
    path: '/session/lock-screen',
    component: LockScreen,
    meta: {
      title: 'Lock Screen',
      breadcrumb: 'Session / Lock Screen'
    }
  }
]

const router = new Router({ mode: 'history', routes })

router.beforeResolve((to, from, next) => {
  if (to.meta.role) {
    if (store.getters['auth/hasRole'](to.meta.role)) {
      next()
    } else {
      store.commit('setMessage', 'Please login to continue', { root: true })
    }
  } else {
    next()
  }
})

export default router
